import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecommendationCardComponent } from './recommendation-card.component';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from 'src/app/pipes/pipes.module';



@NgModule({
  declarations: [RecommendationCardComponent],
  exports: [RecommendationCardComponent],
  imports: [
    CommonModule,
    IonicModule,
    PipesModule
  ]
})
export class RecommendationCardModule { }
